import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    productNumber: string;
    customerProductNumber?: string;
    manufacturerItem?: string;
    showCustomerName?: boolean;
    showManufacturerItem?: boolean;
    extendedStyles?: ProductPartNumbersStyles;
    showProductNumber?: boolean;
}

type Props = OwnProps;

export interface ProductPartNumbersStyles {
    condensed?: boolean;
    container?: InjectableCss;
    containerItem?: InjectableCss;
    erpNumberLabelText?: InjectableCss;
    erpNumberValueText?: InjectableCss;
    customerNameGridItem?: InjectableCss;
    customerNameLabelText?: TypographyPresentationProps;
    customerNameValueText?: TypographyPresentationProps;
    manufacturerItemGridItem?: InjectableCss;
    manufacturerItemLabelText?: TypographyPresentationProps;
    manufacturerItemValueText?: TypographyPresentationProps;
}

export const productPartNumbersStyles: ProductPartNumbersStyles = {
    erpNumberLabelText: {
        css: css`
            flex: 0 0 auto;
            font-weight: 700;
        `,
    },
    erpNumberValueText: {
        css: css`
            flex: 1 1 auto;
            min-width: 0;
        `,
    },
    customerNameLabelText: {
        css: css`
            flex: 0 0 auto;
        `,
    },
    customerNameValueText: {
        css: css`
            flex: 1 1 auto;
            min-width: 0;
        `,
    },
    manufacturerItemLabelText: {
        css: css`
            flex: 0 0 auto;
            font-weight: 700;
        `,
    },
    manufacturerItemValueText: {
        css: css`
            flex: 1 1 auto;
            min-width: 0;
        `,
    },
    container: {
        css: css`
            // border: 1px dotted green;
            // border-right: none;
            // border-left: none;
            display: flex;
            flex-wrap: wrap;
            flex-basis: 100%;
        `,
    },
    containerItem: {
        css: css`
            flex: 50%;
            line-height: 1.2;
            font-size: 14px;
            padding: 5px 15px 5px 15px;
        `,
    },
};

const ProductPartNumbers: FC<Props> = ({
    productNumber,
    customerProductNumber,
    manufacturerItem,
    showCustomerName = true,
    showManufacturerItem = true,
    extendedStyles,
    showProductNumber = true,
}) => {
    const [styles] = React.useState(() => mergeToNew(productPartNumbersStyles, extendedStyles));
    const displayManufacturerNumber = showManufacturerItem && manufacturerItem;
    const displayCustomerNumber = showCustomerName && customerProductNumber;
    const numberOfItems = 1 + (displayManufacturerNumber ? 1 : 0) + (displayCustomerNumber ? 1 : 0);
    const mobileGridItemWidth = numberOfItems > 1 ? 6 : 12;
    const desktopGridItemWidth = 12 / numberOfItems;

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.containerItem}>
                <Typography as="p" {...styles.erpNumberLabelText}>
                    {translate("Stellar Part #")}
                </Typography>
                <Typography as="p" {...styles.erpNumberValueText}>
                    {productNumber}
                </Typography>
            </StyledWrapper>
            {displayCustomerNumber && (
                <StyledWrapper {...styles.containerItem}>
                    <Typography as="p" {...styles.customerNameLabelText}>
                        {translate("CPN:")}
                    </Typography>
                    <Typography as="p" data-test-selector="customerProductNumber" {...styles.customerNameValueText}>
                        {customerProductNumber}
                    </Typography>
                </StyledWrapper>
            )}
            {displayManufacturerNumber && (
                <StyledWrapper {...styles.containerItem}>
                    <Typography as="p" {...styles.manufacturerItemLabelText}>
                        {translate("MFG Part #")}{" "}
                    </Typography>
                    <Typography as="p" data-test-selector="manufacturerItem" {...styles.manufacturerItemValueText}>
                        {manufacturerItem}
                    </Typography>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default ProductPartNumbers;
